{
	"title": "Zarządzaj deklaracjami",
	"createDeclaration": "Utwórz deklarację"
}
